import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";

const { t } = i18n;
export const onSubmit = async (values, props) => {
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;

  if (!values?.leasingItem) return;

  const leasingItemPayload = {
    uuid: update ? values.uuid : undefined,
    car:
      values.leasingItem.type === "car"
        ? { uuid: values.leasingItem.uuid }
        : null,
    device:
      values.leasingItem.type === "device"
        ? { uuid: values.leasingItem.uuid }
        : null,
    name: values.name || null,
    description: values.description || null,
    type: values.type || null,
  };

  let payload;

  if (!update) {
    // CREATE
    const res = await GlobalAuthFetch({
      path: `/leasing/${uuid}/addLeasingItem`,
      method: "PATCH",
      data: leasingItemPayload,
    });
    payload = res.payload;
  } else {
    // UPDATE
    const res = await GlobalAuthFetch({
      path: `/leasing/leasingItem/${values.uuid}`, // edytujemy istniejący
      method: "PATCH", // albo PATCH jeśli backend tak przyjmuje
      data: leasingItemPayload,
    });
    payload = res.payload;
  }

  if (!payload?.status || payload.status >= 300) {
    props.setErrorHeader(0, true);
    return;
  }

  props.setErrorHeader(0, false);
  loadData();
  NotificationManager.success(t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  // const { update } = props;
  const errorsStep0 = {};

  if (!values.leasingItem) {
    errorsStep0.leasingItem = t("global:leasing.errors.leasingItem");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
